"use client";
import { useEffect, useRef, useState } from "react";
import { Heading } from "@/components/ui/typography";

export default function WhatHappensSection({ heading = "Here's What Happens After Your Call Zero-Tax HK Structure" }: { heading?: string } = {}) {
  const textRef = useRef<HTMLDivElement>(null);
  const [progress, setProgress] = useState(0);

  const text = `If you're researching how Hong Kong company tax setup works step by step, you're probably trying to understand what actually happens after signing up, and whether this becomes complicated for you personally. It doesn’t. We've turned what used to take months of lawyers and accountants into a streamlined 14-day process designed for online founders running international businesses. Here's exactly what happens.`;

  const words = text.split(" ");

  useEffect(() => {
   const handleScroll = () => {
  if (!textRef.current) return;

  const rect = textRef.current.getBoundingClientRect();

  const elementTop = rect.top;
  const elementHeight = rect.height;
  const windowHeight = window.innerHeight;

  // start when element enters bottom
  const start = windowHeight;
  const end = -elementHeight;

  const progress = (start - elementTop) / (start - end);

  setProgress(Math.min(1, Math.max(0, progress)));
};

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="w-full bg-black py-[60px]">

      {/* CONTAINER */}
      <div className="max-w-[1200px] mx-auto px-4 flex flex-col items-center gap-12">

        {/* HEADING */}
        <Heading as="h2" variant="sectionCentered" className="max-w-[700px]">
          {heading}
        </Heading>

        {/* CONTENT BOX */}
        <div className="w-full max-w-[1200px] bg-[#0f1218] border border-white/10 rounded-xl p-10">

          {/* TEXT */}
          <div
            ref={textRef}
            className="text-[18px] lg:text-[24px] leading-[160%] tracking-[-0.5px] font-inter font-medium max-w-[960px] mx-auto"
          >
            {words.map((word, i) => {
              const threshold = i / words.length;

              return (
                <span
                  key={i}
                  className={`transition-colors duration-300 ${
                    progress > threshold
                      ? "text-white/70"
                      : "text-white/20" // faded
                  }`}
                >
                  {word}{" "}
                </span>
              );
            })}
          </div>

        </div>

      </div>
    </section>
  );
}